import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getHasSavedResults } from 'ctm-selectors/selectors/results';
import { Button } from '../../button/button';

class _ApplyFiltersButton extends Component {

    /**
     * onClick event handler. Dispatch all required actions and also dispatch an action to reload the page
     * if we have to fetch new results (based on filters config).
     */
    onClick = () => {
        const { dispatch, fetchNewResults } = this.props;
        const hasSavedResults = getHasSavedResults();

        dispatch({
            type: 'ACTIVATE_STAGED_FILTERS'
        });

        dispatch({
            type: 'GET_MODELLED_ELECTRICITY_USAGE'
        });

        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUES',
            actions: [
                {
                    key: 'filterDisplayMode',
                    value: ''
                },
                {
                    key: 'filters.showFiltersUpdateButton',
                    value: false
                }
            ]

        });

        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'lastViewedPage',
            value: 'results'
        });

        if (hasSavedResults) {
            dispatch({
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'helpers.updateQuoteModal',
                value: { open: true }
            });
            dispatch({
                type: 'SET_VALUE',
                identifier: 'helpers.prefill.isResultsFilterActive',
                stateKey: 'vertical.quote',
                value: true
            });
        } else if (fetchNewResults) {
            dispatch({
                type: 'SET_PAGE_VALUE',
                identifier: 'doReload',
                value: true
            });
        }
    };

    /**
     * Render the ApplyFiltersButton
     * @returns {Node} - The ApplyFiltersButton
     */
    render = () => {
        return (
            <Button
                icon="ctm_reload"
                iconPosition="before"
                label="Update results"
                UIComponent="btn_secondary_medium_semi_rounded"
                variant="full_width"
                onClick={this.onClick}
            />
        );
    };

}

_ApplyFiltersButton.propTypes = {
    fetchNewResults: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    return {
        fetchNewResults: state.getIn(['vertical', 'quote', 'results', 'config', 'filters', 'fetchNewResults'])
    };
};

export { _ApplyFiltersButton };
export const ApplyFiltersButton = connect(mapStateToProps)(_ApplyFiltersButton);
